import * as api from "api"
import { schemaCommon } from "common/bit/form/FormikSchema"
import * as yup from "yup"

export type TreatmentMaxMinTime = {
  minTime: number
  maxTime: number
}
type TreatmentTypesOptions = {
  id: api.TreatmentType
  name: string
  minMaxTime?: TreatmentMaxMinTime
}

export const treatmentTypes: TreatmentTypesOptions[] = [
  {
    id: "PeriodicTreatment",
    name: "טיפול תקופתי",
    minMaxTime: { minTime: 7, maxTime: 9 },
  },
  { id: "Problem", name: "תקלה", minMaxTime: { minTime: 9, maxTime: 11 } },
  { id: "Accident", name: "תאונה", minMaxTime: { minTime: 9, maxTime: 11 } },
]
export const generalMaxMinTime = { minTime: 10, maxTime: 14 }

export const ACCIDENT_DESCRIPTION_MAX_LENGTH = 300
export const PROBLEM_DESCRIPTION_MAX_LENGTH = 300

export const schema = yup
  .object({
    fullName: schemaCommon.fullName,
    phoneNumber: schemaCommon.phoneNumber,
    licenseNumber: schemaCommon.licenseNumber,
    treatmentDate: yup.mixed<Date>().required("שדה חובה"),
    // Allow empty string as initial value for select
    treatmentType: yup
      .string()
      .oneOf(["", "PeriodicTreatment", "Problem", "Accident"], "שדה חובה")
      .required("שדה חובה"),
    problemDescription: yup.string().when("treatmentType", {
      is: "Problem",
      then: (schema) =>
        schema
          .required("שדה חובה")
          .max(
            PROBLEM_DESCRIPTION_MAX_LENGTH,
            `מקסימום תווים ${PROBLEM_DESCRIPTION_MAX_LENGTH} characters`
          ),
      otherwise: (schema) =>
        schema.max(
          PROBLEM_DESCRIPTION_MAX_LENGTH,
          `מקסימום תווים ${PROBLEM_DESCRIPTION_MAX_LENGTH} characters`
        ),
    }),
  })
  .defined()

export const initialFormState: yup.InferType<typeof schema> = {
  fullName: "",
  phoneNumber: "",
  licenseNumber: "",
  treatmentDate: new Date(),
  treatmentType: "",
  problemDescription: "",
}
